export const PAGE_TITLES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/users': 'Users',
  '/matches': 'Interested Matches',
  '/notifications': 'Notifications',
  '/reports': 'Reports',
  '/payments': 'User Payments',
};